import tw from 'tailwind-styled-components'

export const ReportMainContainer = tw.div`
md:mx-12
mx-6
md:my-8
my-4
bg-white
boxShadow
rounded-lg
min-w-[380px]
relative
min-h-[500px]
`
export const ReportTitleContainer = tw.div`
`
export const ReportTitle = tw.span`
text-blueTheme
font-bold
text-lg
`
export const ExportTitle = tw.span`
text-blueTheme
font-semibold
text-lg
`
export const ReportExportContainer = tw.div`
pl-[75px] pr-[75px] pt-[45px]
`
export const ReportExportContent = tw.div`
border border-borderLine rounded-lg
min-h-[119px]
`
export const HrCustomLine = tw.hr`
h-px w-full bg-borderLine
`
export const FilterMainContainer = tw.div`
pt-8
pl-8
pr-4
bg-greyWhite 
max-w-[220px] 
h-full 
min-h-[680px]
`
export const ExportButton = tw.button`
w-[176px]
h-[38px]
border 
rounded-lg 
border-amberAlt
text-amberAlt
font-medium
text-sm
flex
items-center
justify-center
gap-2
focus:outline-none
transition-all
`
export const FilterButton = tw.button`
mb-6
h-[38px]
w-[170px]
inline-flex
items-center
justify-center
border
rounded-lg
border-blueTheme
text-blueTheme
text-sm
cursor-pointer
active:scale-95
transition-colors
hover:brightness-90
bg-white
`


export const FilterTitle = tw.span`
mb-2
text-darkGray
font-semibold
text-base
`
export const FilterSection = tw.div`
mt-4
`
export const FiltersLabels = tw.div`
mb-2
text-darkGray
font-semibold
text-xs
`

export const ReportDataMainContainer = tw.div`
`
export const ReportDataContainer = tw.div`
pt-6
pl-4
pr-4
`
export const ReportDataGeneral = tw.div`
mb-4
`
export const ReportDataNew = tw.div`
`

export const disabledExport = `
bg-disabled
text-mediumGray
border-mediumGray
`
